import {
  useEffect,
  useState,
  lazy,
  Suspense,
  useCallback,
  useMemo,
  useRef,
  startTransition,
} from "react";
import axios from "axios";
import Banner from "../components/homepage/Banner";
import GoToTop from "../helpers/GoToTop";
import MetaData from "../helpers/MetaData";
import ApiService from "../api/ApiService";
import JanmashtamiSchedule from "../components/homepage/JanmashtamiSchedule.jsx";
import LivePooja from "../components/homepage/LivePooja.jsx";
// Lazy load components that are not immediately visible
const WelcomeToIskcon = lazy(() =>
  import("../components/homepage/WelcomeToIskcon")
);
const UpcomingImmersions = lazy(() =>
  import("../components/homepage/UpcomingImmersions")
);
const Sheduled = lazy(() => import("../components/homepage/Sheduled"));
const Eventshome = lazy(() => import("../components/blog/BlogSlider.jsx"));
const YoutubeVideo = lazy(() =>
  import("../components/homepage/YoutubeVideo.jsx")
);
const OnDemandCourses = lazy(() =>
  import("../components/homepage/OnDemandCourses.jsx")
);
const Cta = lazy(() => import("../components/homepage/Cta.jsx"));
const InstagramSection = lazy(() =>
  import("../components/homepage/instagramSection.jsx")
);
// const LivePooja = lazy(() => import("../components/homepage/LivePooja.jsx"))

// Enhanced loading component with better UX
const ComponentLoader = ({ height = "200px", message = "Loading..." }) => (
  <div
    className="d-flex align-items-center justify-content-center"
    style={{
      height,
      backgroundColor: "#f8f9fa",
      border: "1px solid #e9ecef",
      borderRadius: "8px",
      margin: "10px 0",
    }}
  >
    <div className="d-flex align-items-center gap-2">
      <div
        className="spinner-border spinner-border-sm text-primary"
        role="status"
        aria-hidden="true"
      ></div>
      <span className="text-muted">{message}</span>
    </div>
  </div>
);

// Error boundary component for lazy loaded components
const LazyErrorBoundary = ({ children, fallback }) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

const Home = () => {
  const [instadata, setInstadata] = useState([]);
  const [profileLogoinsta, setProfileLogo] = useState(null);
  const [meta, setMeta] = useState(null);
  const [apiKey, setApikey] = useState(null);
  const [isInstaLoading, setIsInstaLoading] = useState(false);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [instagramError, setInstagramError] = useState(null);
  const [setting, setSetting] = useState([]);
  const [loading, setLoading] = useState(true);
  // Track which sections have been loaded
  const [loadedSections, setLoadedSections] = useState(new Set());

  // Memoize static values
  const playlistId = useMemo(() => "PLF5RK46EWmw1-JVrzKaqfA7ktW3GQjHLY", []);
  const channelId = useMemo(() => "UCMze6fxA4QX8mYtCb0qwsrw", []);
  const HomepagescheduleRef = useRef();
  // const HomepagescheduleRef = useRef();
  // Optimized Instagram data fetching with error handling
  const fetchInstagramData = useCallback(async () => {
    if (isInstaLoading || loadedSections.has("instagram")) return;

    setLoadedSections((prev) => new Set(prev).add("instagram"));
    setIsInstaLoading(true);
    setInstagramError(null);

    try {
      const apidata = await ApiService.fetchInstagramData();
      setInstadata(apidata?.data || []);
      setProfileLogo(apidata?.ProfileLogo || null);
    } catch (error) {
      console.error("Instagram data fetching error:", error);
      setInstagramError(error.message || "Failed to fetch Instagram data");
      setInstadata([]);
      setProfileLogo(null);
    } finally {
      setIsInstaLoading(false);
    }
  }, [isInstaLoading, loadedSections]);

  // Optimized API key fetching
  const fetchApiKey = useCallback(async () => {
    if (isApiLoading || loadedSections.has("youtube")) return;

    setLoadedSections((prev) => new Set(prev).add("youtube"));
    setIsApiLoading(true);

    try {
      const apidata = await ApiService.getGoogleapikey();
      setApikey(apidata?.key || null);
    } catch (error) {
      console.error("API key fetch error:", error);
      setApikey(null);
    } finally {
      setIsApiLoading(false);
    }
  }, [isApiLoading, loadedSections]);

  // Optimized meta data fetching
  const fetchMeta = useCallback(async () => {
    try {
      const res = await ApiService.fetchMetaData("home");
      setMeta(res);
    } catch (error) {
      console.error("Meta fetch error:", error);
      setMeta(null);
    }
  }, []);

  // Load critical data immediately
  useEffect(() => {
    fetchMeta();
  }, [fetchMeta]);

  // Prefetch critical resources
  useEffect(() => {
    // Prefetch important resources
    const prefetchTimer = setTimeout(() => {
      const link = document.createElement("link");
      link.rel = "prefetch";
      link.href = "/images/banner.jpg"; // Adjust to your banner image
      document.head.appendChild(link);
    }, 1000);

    return () => clearTimeout(prefetchTimer);
  }, []);

  useEffect(() => {
    const fetchAdminSetting = async () => {
      try {
        setLoading(true);
        const res = await ApiService.fetchAdminSetting();

        // Make sure response has proper structure
        setSetting(res.settings || res); // Adjust based on your API response
      } catch (error) {
        console.error("Error fetching admin settings:", error);
        // Set default settings on error
        setSetting({
          socialMedia: {},
          other: {},
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAdminSetting();
  }, []);

  return (
    <>
      <MetaData
        title="ISKCON of Attapur — Dissolve in Krishna Consciousness"
        meta={meta}
      />

      {/* Critical above-the-fold content loads immediately */}
      <Suspense
        fallback={
          <ComponentLoader height="100vh" message="Loading banner section..." />
        }
      >
        <Banner scheduleRef={HomepagescheduleRef} />
        {/* <Banner /> */}
      </Suspense>

      {/* Non-critical content with optimized lazy loading */}
      <LazyErrorBoundary
        fallback={
          <ComponentLoader
            height="300px"
            message="Loading welcome section..."
          />
        }
      >
        <WelcomeToIskcon />
      </LazyErrorBoundary>

      <LazyErrorBoundary
        fallback={
          <ComponentLoader
            height="400px"
            message="Loading upcoming immersions..."
          />
        }
      >
        <UpcomingImmersions />
      </LazyErrorBoundary>
      {/* <div ref={HomepagescheduleRef}>
                <JanmashtamiSchedule />
            </div> */}
      {setting.socialMedia && setting.socialMedia.zoomPuja && (
        <div ref={HomepagescheduleRef}>
          <LivePooja />
        </div>
      )}

      {setting.socialMedia && setting.socialMedia.instagram && (
        <LazyErrorBoundary
          fallback={
            <ComponentLoader
              height="500px"
              message="Loading Instagram content..."
            />
          }
        >
          <InstagramSection
            logo={profileLogoinsta}
            instadata={instadata}
            isLoading={isInstaLoading}
            error={instagramError}
            onRetry={fetchInstagramData}
            onMount={fetchInstagramData} // ✅ New prop
          />
        </LazyErrorBoundary>
      )}

      {setting.socialMedia && setting.socialMedia.youtube && (
        <LazyErrorBoundary
          fallback={
            <ComponentLoader
              height="400px"
              message="Loading YouTube videos..."
            />
          }
        >
          <YoutubeVideo
            channelId={channelId}
            playlistId={playlistId}
            apiKey={apiKey}
            isLoading={isApiLoading}
            onMount={fetchApiKey} // ✅ New prop
          />
        </LazyErrorBoundary>
      )}

      <LazyErrorBoundary
        fallback={<ComponentLoader height="300px" message="Loading blogs..." />}
      >
        <Eventshome header="BLOGS" />
      </LazyErrorBoundary>

      <LazyErrorBoundary
        fallback={
          <ComponentLoader height="400px" message="Loading courses..." />
        }
      >
        <OnDemandCourses />
      </LazyErrorBoundary>

      <LazyErrorBoundary
        fallback={
          <ComponentLoader height="300px" message="Loading schedule..." />
        }
      >
        <Sheduled />
      </LazyErrorBoundary>

      <LazyErrorBoundary
        fallback={
          <ComponentLoader height="200px" message="Loading call-to-action..." />
        }
      >
        <Cta />
      </LazyErrorBoundary>

      <GoToTop />
    </>
  );
};

export default Home;
